import React from 'react';
import { useTagsContext } from './TagsContext/TagsContext';
import { TagsSkeleton } from './TagsSkeleton';
import { TagsContainer } from './TagsContainer';

export const TagsWrapper = () => {
    const { isLoading } = useTagsContext();

    if (isLoading) {
        return <TagsSkeleton />;
    }

    return <TagsContainer />;
};
